"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { row, title, description } from './styles.js';
import { useTheme } from '../utils/theming/useTheme.js';

var _excluded = ["label", "children"];
var DescriptionListItem = function DescriptionListItem(_ref) {
  var label = _ref.label,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(row, _extends({
    "data-testid": "elemental-DescriptionListItem-".concat(label)
  }, props), /*#__PURE__*/React.createElement(title, {
    theme: theme
  }, label), /*#__PURE__*/React.createElement(description, {
    theme: theme
  }, children));
};

export { DescriptionListItem };
